// src/components/utils/ErrorMessageUI.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

// Ten komponent przyjmuje błąd i errorInfo jako propsy (do ewentualnego wyświetlenia w trybie dev)
function ErrorMessageUI({ error, errorInfo }) {
  const { t } = useTranslation(); // Używamy hooka do tłumaczeń

  return (
    <div style={{ padding: '20px', border: '1px solid red', margin: '10px' }}>
      {/* Używamy funkcji t() z kluczami z i18n */}
      <h2>{t('errorBoundary.title')}</h2>
      <p>{t('errorBoundary.message')}</p>
      {process.env.NODE_ENV === 'development' && error && (
        <details style={{ whiteSpace: 'pre-wrap', marginTop: '10px' }}>
          <summary>{t('errorBoundary.detailsToggle')}</summary>
          {error.toString()}
          <br />
          {errorInfo?.componentStack}
        </details>
      )}
    </div>
  );
}

export default ErrorMessageUI;
